// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollLock_container__384x3","locked":"ScrollLock_locked__3WaLI","unlocked":"ScrollLock_unlocked__2a201","button":"ScrollLock_button__2cJng"};